module.exports = __webpack_public_path__ + "img/sPutHB.29171641.svg";